import React from 'react';
import Select from 'react-select';
// import PropTypes from 'prop-types';


const SelectBrokers = (props) => {
    let brokers = props.data;
    let selectedBrokers = props.selectedBrokers.map( v => v.value +',  ');

    const TempData = JSON.parse(localStorage.getItem('tempOnboardingData'));
    let company_brokers = TempData && TempData.company_brokers;
    company_brokers = company_brokers !== "" && JSON.parse(company_brokers);
    let brokersToShow = [];
    if (company_brokers) {
        company_brokers.map(v => brokersToShow.push({ label: v.label, value: v.value }));
    }
    
    return (
        <div className="brd_tab_cntnt">
            <span className="payers_title">
                Select BROKERS you work with
            </span>
            <div className="brding_frm_ele fix_payers_margin">
                <span>Select brokers</span>
                <Select
                    closeMenuOnSelect={true}
                    isMulti
                    options={brokers}
                    className="select_payers_cls"
                    onChange={(val) => props.onSelectBrokers(val)}
                    defaultValue={brokersToShow}

                />
            </div> <br />
            <div className="brding_frm_ele">
                <span>Selected</span>
                <p id="selectedBrokers" className="items-selected" value={JSON.stringify(props.selectedBrokers)}> {selectedBrokers}</p>
            </div> <br />


        </div>
    )
};

export default SelectBrokers;


// WEBPACK FOOTER //
// ./src/app/setup_onboarding/comps/SelectBrokers.js